import { Reducer } from 'redux'
import { CALCULADORA, TYPES } from './types'

const INITIAL_STATE: CALCULADORA = {
  defaultValue: ''
}

const reducer: Reducer<CALCULADORA> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TYPES.ACTION_DEFAULT:
      return { ...state, defaultValue: action.value }
    default:
      return state
  }
}

export default reducer
